import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faOutdent, faHome, faCogs, faList, faFile, faLock, faIndent } from '@fortawesome/free-solid-svg-icons';
import { Nav } from 'reactstrap';

//Components
import SidebarItem from './Components/SidebarItem';
import SubMenu from './Components/SubMenu';

//Context
import { useAuth } from '../../context/auth';

import "../../assets/css/sidebar.css";

export default function Sidebar({ isOpen, setIsOpen, routes }) {
    const { logoSistema, logoPrefeitura, logoSecretaria } = useAuth();

    //Função de onClick do botão de abrir sidebar
    const onClickOpenSidebar = () => {
        setIsOpen(!isOpen);
    }
    return (
        <div className={`sidebar ${!isOpen ? "inactive" : ""}`}>
            <div className="logo">
                <div className="image">
                    <img src={logoSistema} width={100} className='img-logo-sidebar' alt="logo do sistema" />
                </div>
                <button className="topBarBtn" onClick={onClickOpenSidebar}>
                    <FontAwesomeIcon id="topBarBtnIcon" icon={!isOpen ? faIndent : faOutdent} />
                </button>
            </div>
            <div className="side-menu">
                <Nav vertical className={`list-unstyled pb-3 menu ${!isOpen ? "inactive" : ""}`}>
                    {routes.map((route, key) => {
                        if (!route.submenus) {
                            if (route.icon && route.name) {
                                return (<SidebarItem key={key} icon={route.icon} text={route.name} link={route.path} active={route.active} />)
                            }
                        } else {
                            if (route.icon && route.name) {
                                return (<SubMenu key={key} title={route.name} icon={route.icon} items={route.submenus} />)
                            }
                        }
                    })}
                </Nav>
                {
                    (logoPrefeitura || logoSecretaria) &&
                    <div className=" mt-3 d-flex flex-column align-items-center jusitfy-content-center gap-3">
                        {
                            logoPrefeitura &&
                            <img src={logoPrefeitura} className='img-logo-sidebar' alt="logo da prefeitura" />
                        }
                        {
                            logoSecretaria &&
                            <img src={logoSecretaria} className='img-logo-sidebar' alt="logo do sistema" />
                        }
                    </div>
                }
            </div>


        </div>
    )
}